export const ALERT_STYLE = "color: #BBBBBB; stroke-width: 0" as const;
